import { useState, useEffect } from "react";
import ReactGA from "react-ga4";
import { Typography, Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import UserList from "./components/UserList";
import UserDialog from "./components/UserDialog";

import requests from "../../utilities/requests";
import { toast } from "../../utilities/SnackBarUtils";

const BlackList = () => {
  const [blackList, setBlackList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/blacklist",
      title: "Blacklist",
    });
  }, []);

  useEffect(() => {
    getBlackList();
  }, []);

  const getBlackList = async () => {
    const result = await requests("blacklist");
    if (result.success) {
      setBlackList(result.data);
    }
  };

  const handleSelectUser = async (email) => {
    if (!email) {
      setSelectedUser(null);
      return;
    }

    const result = await requests(`blacklist/?email=${email}`);
    if (result.success) {
      setSelectedUser(result.data);
      setDialogOpen(true);
    }
  };

  const handleMessage = (msg) => {
    if (!msg) {
      return;
    }
    getBlackList();
    let message;
    if (msg === "create-success") {
      message = "Record created successfully";
    } else if (msg === "update-success") {
      message = "Record updated successfully.";
    } else if (msg === "delete-success") {
      message = "Record deleted successfully";
    }
    toast.success(message);
  };

  return (
    <div
      style={{
        padding: 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 30,
      }}
    >
      <Typography variant="h5">Blacklist</Typography>
      <UserList
        users={blackList}
        handleSelect={(email) => handleSelectUser(email)}
      />
      <Fab
        color="primary"
        aria-label="add"
        style={{ position: "fixed", bottom: "5%", right: "5%" }}
        onClick={() => setDialogOpen(true)}
      >
        <AddIcon />
      </Fab>
      <UserDialog
        user={selectedUser}
        open={dialogOpen}
        close={(msg) => {
          setDialogOpen(false);
          setSelectedUser(null);
          handleMessage(msg);
        }}
      />
    </div>
  );
};

export default BlackList;
